import { Action, Category } from "constants/events";
import { INITIAL_RESULT_LENGTH } from "constants/search";
import { SearchPageTypes } from "custom-types/Search";
import { useEventTracker } from "hooks/useEventTracker";
import useSearch from "redux/hooks/useSearch";

import Button from "components/botanic/Button";
import ButtonPlaceholder from "components/ButtonPlaceholder";

const SearchViewMoreButton: React.FC<{
  category: SearchPageTypes;
}> = ({ category }) => {
  const { publishEvent } = useEventTracker();

  const {
    loadMoreSearchResults,
    loading,
    searchCategory,
    searchTerm,
    totalCounts,
    ...remaining
  } = useSearch();

  const trackLoadMore = () =>
    publishEvent({
      action: Action.click,
      category: Category.loadMoreResults,
      label: category,
    });

  const handleLoadMore = async () => {
    trackLoadMore();
    loadMoreSearchResults(category, 8);
  };

  const isCategoryTab = searchCategory === category;
  const currentCount = remaining[category].length;

  const buttonText = category === "dispensary" ? "location" : category;

  return loading ? (
    <ButtonPlaceholder className="mt-lg md:max-w-[322px]" />
  ) : !isCategoryTab && currentCount > INITIAL_RESULT_LENGTH ? (
    <Button
      className="mt-lg"
      data-testid={`${category}-results-view-more`}
      href={`/search?q=${searchTerm}&searchCategory=${category}`}
      onClick={trackLoadMore}
      variant="secondary"
    >
      view all {buttonText} results
    </Button>
  ) : isCategoryTab && currentCount < (totalCounts?.[category] || 0) ? (
    <Button
      className="mt-lg"
      data-testid={`${category}-results-load-more`}
      onClick={handleLoadMore}
      variant="secondary"
    >
      load more {buttonText} results
    </Button>
  ) : null;
};

export default SearchViewMoreButton;
